import React, { useState } from 'react';
import { Mail, Loader2 } from 'lucide-react';
import { useToast } from '../hooks/use-toast';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const EmailSubscribe = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { toast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      toast({
        title: "Invalid Email",
        description: "Please enter a valid email address",
        variant: "destructive"
      });
      return;
    }

    setIsSubmitting(true);
    
    try {
      const response = await axios.post(`${BACKEND_URL}/api/subscribe`, { email });
      toast({
        title: "Thank You for Subscribing! 🎉",
        description: "Check your email for a welcome message with tax tips.",
        duration: 5000
      });
      setEmail('');
    } catch (error) {
      const errorMessage = error.response?.data?.detail || "Failed to subscribe. Please try again.";
      toast({
        title: "Error",
        description: errorMessage,
        variant: "destructive"
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="section-padding" style={{ 
      background: 'var(--bg-subtle)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div className="luxury-container" style={{ position: 'relative', zIndex: 1 }}>
        <div style={{ maxWidth: '700px', margin: '0 auto', textAlign: 'center' }}>
          <div style={{ marginBottom: '16px' }}>
            <Mail size={40} strokeWidth={1.5} color="var(--accent-gold)" style={{ margin: '0 auto' }} />
          </div>
          <h2 className="heading-1" style={{ marginBottom: '16px' }}>
            Get Tax Tips All Year Round
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', marginBottom: '40px' }}>
            Subscribe to receive helpful tax reminders, deadlines, and money-saving tips throughout the year.
          </p>
          <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '12px', maxWidth: '500px', margin: '0 auto', flexWrap: 'wrap', justifyContent: 'center' }}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              disabled={isSubmitting}
              style={{
                flex: '1 1 300px',
                minWidth: '250px',
                padding: '18px 20px',
                border: '1px solid var(--border-medium)',
                borderRadius: '0px',
                fontSize: '14px',
                fontFamily: 'Inter, -apple-system, sans-serif',
                background: 'var(--bg-primary)',
                color: 'var(--text-primary)',
                transition: 'border-color 0.2s ease'
              }}
              onFocus={(e) => e.target.style.borderColor = 'var(--interactive-base)'}
              onBlur={(e) => e.target.style.borderColor = 'var(--border-medium)'}
            />
            <button
              type="submit"
              className="btn-primary gold-accent"
              disabled={isSubmitting}
              style={{ minWidth: '140px' }}
            >
              {isSubmitting ? (
                <>
                  <Loader2 size={16} className="animate-spin" />
                  Subscribing...
                </>
              ) : (
                'Subscribe'
              )}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default EmailSubscribe;